import {
  aiProviderBaseUrl,
  getAIProvider,
  resolveAIProviderId,
} from "../../shared/aiProviders";
import type { AiProvider as AiConfig } from "../../shared/generatedDrizzleSchema";

export function getConfigProvider(
  config: Pick<AiConfig, "provider" | "baseUrl">
) {
  return resolveAIProviderId(config);
}

export function getConfigSubtitle(
  config: Pick<AiConfig, "provider" | "baseUrl" | "createdAt">,
  connectorConfiguration?: Record<string, string> | null
) {
  const definition = getAIProvider(getConfigProvider(config));
  if (definition.subtitleField) {
    const credentials = definition.unpackCredentials({
      baseUrl: aiProviderBaseUrl(config, connectorConfiguration) ?? "",
      apiKey: "",
    });
    const value = credentials[definition.subtitleField];
    if (value) return value;
  }
  return `Added ${new Date(config.createdAt).toLocaleDateString()}`;
}
